// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-btn--outlined[data-v-2e5b2345] {\n  border: thin solid #fff;\n}\n.v-btn.v-size--x-large[data-v-2e5b2345] {\n  height: 70px;\n  min-width: 240px;\n}\n.disable-events[data-v-2e5b2345] {\n  pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
